import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgModel } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'reassignment-dialog',
  templateUrl: './reassignment-dialog.component.html',
  styleUrls: ['./reassignment-dialog.component.scss'],
})
export class ReassignmentDialogComponent implements OnInit {
  @ViewChild('emailCtrl') emailCtrl!: NgModel;
  newOwner = { name: '', code: '', email: '', mobile: '' };
  ownerList: { name: string; email?: string, code?: string, mobile?: string; }[] = [];
  fundList: string[] = [];
  filteredFunds: string[] = [];
  selectedFunds: string[] = [];
  fundSearch = '';
  filteredEmails: string[] = [];
  validationError: string | null = null;
  selectedEmailFromSuggestion: string | null = null;

  constructor(
    private dialogRef: MatDialogRef<ReassignmentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    if (this.data?.ownerList) {
      this.ownerList = this.data.ownerList;
    }
    const rowFundList = this.data?.current?.fundList || [];
    this.fundList = rowFundList.map((f: any) => f.fundName);
    this.filteredFunds = [...this.fundList];
    this.selectedFunds = [...this.fundList];
  }


  filterFunds() {
    const search = this.fundSearch.toLowerCase();
    this.filteredFunds = this.fundList.filter(f => f.toLowerCase().includes(search));
  }

  isAllFundsSelected(): boolean {
    return (
      this.filteredFunds.length > 0 &&
      this.filteredFunds.every(f => this.selectedFunds.includes(f))
    );
  }

  toggleSelectAllFunds(event: any) {
    if (event.checked) {
      const newSelections = this.filteredFunds.filter(
        f => !this.selectedFunds.includes(f)
      );
      this.selectedFunds = [...this.selectedFunds, ...newSelections];
    } else {
      this.selectedFunds = this.selectedFunds.filter(
        f => !this.filteredFunds.includes(f)
      );
    }
  }

  toggleFund(fund: string, event: any) {
    if (event.checked) {
      if (!this.selectedFunds.includes(fund)) {
        this.selectedFunds = [...this.selectedFunds, fund];
      }
    } else {
      this.selectedFunds = this.selectedFunds.filter(f => f !== fund);
    }
  }

  filterEmails(value: string): void {
    if (!value) {
      this.filteredEmails = [];
      return;
    }

    const search = value.toLowerCase();

    this.filteredEmails = this.ownerList
      .map(o => o.email)
      .filter(
        (email): email is string =>
          !!email && email.toLowerCase().includes(search)
      );
  }

  onEmailSelected(email: string): void {
    const owner = this.ownerList.find(o => o.email === email);
    if (!owner) return;

    //  store selected email
    this.selectedEmailFromSuggestion = email;

    this.newOwner.email = email;
    this.newOwner.name = owner.name;

    if (this.data?.type === 'RM') {
      this.newOwner.code = owner.code || '';
      this.newOwner.mobile = '';
    } else {
      this.newOwner.mobile = owner.mobile || '';
      this.newOwner.code = '';
    }

    this.validateEmail(email);
  }

  onEmailChange(value: string): void {
    this.filterEmails(value);
    this.validateEmail(value);

    //  If user edits the email after selecting from autocomplete
    if (
      this.selectedEmailFromSuggestion &&
      value !== this.selectedEmailFromSuggestion
    ) {
      // ❌ clear auto-filled data
      this.newOwner.name = '';
      this.newOwner.code = '';
      this.newOwner.mobile = '';

      // reset selected email
      this.selectedEmailFromSuggestion = null;
    }
  }

  close() {
    this.dialogRef.close();
  }


  save(): void {
    if (this.validationError) return;

    this.dialogRef.close({
      newOwner: this.newOwner,
      selectedFunds: this.selectedFunds,
      type: this.data.type
    });
  }

  validateEmail(value: string): void {
    if (!value) {
      this.validationError = null;
      return;
    }

    const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.(in|com)$/;

    if (!EMAIL_REGEX.test(value.toLowerCase())) {
      this.validationError = 'Invalid email format';

      //  IMPORTANT: mark control as invalid
      this.emailCtrl?.control?.setErrors({ invalidEmailDomain: true });
      return;
    }

    //  clear error if valid
    if (this.emailCtrl?.control?.hasError('invalidEmailDomain')) {
      this.emailCtrl.control.setErrors(null);
    }

    const oldEmail = this.data?.current?.email?.toLowerCase();
    if (oldEmail === value.toLowerCase()) {
      this.validationError = 'Selected RM is already assigned';
      return;
    }

    this.validationError = null;
  }
}
